import type {
  DealConstructionBase,
  DealConstructionContextBase
} from '~/models/DealConstruction';
import type { ConstructionItem } from './ConstructionItem';
import {
  type DealEstimationHistoryContext,
  type OperationType,
  hasDraftEstimations
} from './DealEstimationHistory';

export type DealEstimationEdit = Omit<DealEstimation, 'id' | 'seq'>;
export type DealEstimation = DealConstructionBase & {
  constructionItem: ConstructionItem;
  operationType: OperationType;
  type: 'DealEstimation';
};

// TODO: ContextがReactのContextと混同されるので、名前を変更する
export type DealEstimationContext = DealConstructionContextBase & {
  managementFee: number;
  vendorFee: number;
  note: string | null;
  type: 'DealEstimationContext';
};

const hasAcceptedEstimations = (
  dealEstimationContext: DealEstimationContext
): boolean => dealEstimationContext.dealConstructions.length !== 0;

export const hasAnyEstimations = (
  estimationContext: DealEstimationContext,
  dealEstimationHistoryContext: DealEstimationHistoryContext
): boolean =>
  hasAcceptedEstimations(estimationContext) ||
  hasDraftEstimations(dealEstimationHistoryContext);
